import { massOperation, serviceBase } from "../service";

const DocumentTemplate = {
  ...serviceBase,
  resource: "document-templates",
  copy: massOperation("copy"),
  move: massOperation("move")
};
export default DocumentTemplate;
